<app-header [clicked]="clickedOutside" (changeMegaMenuCondition)="changeMenuCondition($event)"
 (selectedLanguage)="switchedLanguage($event)"></app-header>
<!-- App Banner -->
<app-product-banner [showBanks]="true" [selectedLanguage]="selectedLanguage"></app-product-banner>
<!-- App Banner -->
<!-- APp Content Area -->
<div
    class="tw-px-6 tw-py-6 lg:tw-px-20 tw-flex tw-flex-col lg:tw-flex-row tw-items-center tw-justify-between tw-gap-10 lg:tw-h-[270px]">
    <app-product-content></app-product-content>
</div>
<!-- App Content Area -->
<!-- APp Benefits Area -->
<!-- <div
    class="tw-px-6 tw-py-6 lg:tw-px-20 tw-flex tw-flex-col lg:tw-flex-row tw-items-center tw-justify-between tw-gap-10 lg:tw-h-[300px]"> -->
<app-product-benefits></app-product-benefits>
<!-- </div> -->
<!-- APp Benefits Area -->
<!-- APP product Lists -->
<app-product-lists [showBanks]="true" [showAlternateFinancing]="true" [showDigitalBanks]="true"
 [disableMatchingProductsBtn]="disableMatchingProductsBtn"
 [bankProductsList]="bankProductsList" [p2pProductsList]="p2pProductsList" [digitalBankProductsList]="digitalBankProductsList"
 (openProductsClick)="openProducts($event)" [dialogClosed]="dialogClosed" [selectedLanguage]="selectedLanguage"></app-product-lists>
<!-- APP product Lists -->
<!-- App Steps area -->

<app-product-steps [showBanks]="true" (clickEligibility)="onClickEligibility()" [disableMatchingProductsBtn]="disableMatchingProductsBtn"  
[selectedLanguage]="selectedLanguage"></app-product-steps>
<!-- App Steps area -->
<app-footer (click)="closeMegaMenuCondition()"></app-footer>